// Module
var code = "<div ng-if=\"title\" class=\"modal-header\">\n    <div class=\"modal-title\">\n        <h4>{{title}}</h4>\n    </div>\n</div>\n<div ng-if=\"body\" class=\"modal-body\">\n    {{body}}\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-primary\" ng-click=\"$close()\">{{dismissText ? dismissText : 'Close'}}</button>\n</div>";
// Exports
module.exports = code;